// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"3e3c0699","3551":"f0d7e462","4439":"c8191547","5248":"db05bb20","9548":"ade33fef"}[chunkId] + ".chunk.css";
};